import { render, staticRenderFns } from "./ChangeAudit.vue?vue&type=template&id=0537983c&scoped=true&"
import script from "./ChangeAudit.vue?vue&type=script&lang=js&"
export * from "./ChangeAudit.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAudit.vue?vue&type=style&index=0&id=0537983c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0537983c",
  null
  
)

export default component.exports